import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCEEDED,
  SEND_PASSWORD_RESET_LINK,
  SEND_PASSWORD_RESET_LINK_FAILED,
  SEND_PASSWORD_RESET_LINK_SUCCEEDED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCEEDED,
  CLEAR_UPDATE_PASSWORD_ERROR,
} from 'Redux/Types/PasswordResetTypes'

const INITIAL_STATE = {
  sent: false,
  changed: false,
  changePasswordError: null,
  updatePasswordError: null,
  updatingPassword: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CHANGE_PASSWORD:
      return {
        ...state,
        changed: false,
        changePasswordError: null,
      }
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        changed: false,
        changePasswordError: payload,
      }
    case CHANGE_PASSWORD_SUCCEEDED:
      return {
        ...state,
        changed: true,
      }

    case SEND_PASSWORD_RESET_LINK:
      return {
        ...state,
        sent: false,
      }
    case SEND_PASSWORD_RESET_LINK_FAILED:
      return {
        ...state,
        sent: false,
      }
    case SEND_PASSWORD_RESET_LINK_SUCCEEDED:
      return {
        ...state,
        sent: true,
      }

    case UPDATE_PASSWORD:
      return {
        ...state,
        updatingPassword: true,
        updatePasswordError: null,
      }
    case UPDATE_PASSWORD_FAILED:
      return {
        ...state,
        updatingPassword: false,
        updatePasswordError: payload,
      }
    case UPDATE_PASSWORD_SUCCEEDED:
      return {
        ...state,
        updatingPassword: false,
      }

    case CLEAR_UPDATE_PASSWORD_ERROR: {
      return {
        ...state,
        updatePasswordError: null,
      }
    }

    default:
      return state
  }
}
